import ProductAlternative from './ProductAlternative.vue'

export default ProductAlternative
